import React, { useEffect, useState, useRef } from "react";
import {
  GET_ALL_JACKPOT_JODI_CHART,
  GET_ALL_STARLINE_PANA_CHART,
} from "../../service/admin.service";
import { ArrowDown, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";


export default function AllSpecialCharts({ type }) {
    const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null); // for auto-scroll
   const footerRef = useRef(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const res =
        type === "jackpot"
          ? await GET_ALL_JACKPOT_JODI_CHART()
          : await GET_ALL_STARLINE_PANA_CHART();

      setData(Array.isArray(res?.data) ? res.data : []);
    } catch (e) {
      console.error(e);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [type]);

  // Auto scroll to bottom
  useEffect(() => {
    if (!loading && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [loading]);

  // Filter headers: only include columns where at least one row has real data
  const headers = data?.[0]?.results
    ?.map((r) => r.providerName)
    ?.filter((col) =>
      data.some((day) =>
        day.results.some(
          (res) =>
            res.providerName === col &&
            res.winningDigit &&
            res.winningDigit !== "**"
        )
      )
    ) || [];

      const handleClick = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const skeletonCols = headers.length || 8;
  const skeletonRows = 6;

  return (
    <div className="tw-max-w-7xl tw-mx-auto tw-px-3 md:tw-px-6 tw-py-10 tw-mt-20">
      <h2 className="tw-text-2xl md:tw-text-4xl tw-font-bold tw-mb-6 tw-text-center tw-root-color">
        {type === "jackpot" ? "ALL JACKPOT CHART" : "ALL STARLINE CHART"}
      </h2>

       {/* Go Bottom */}
                <div className="tw-text-center tw-mb-8">
                  <button
                    onClick={handleClick}
                    className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mx-auto hover:tw-scale-105 tw-transition"
                  >
                    Go To Bottom
                    <ArrowDown className="tw-w-4 tw-h-4" />
                  </button>
                </div>

      <div className="tw-bg-white tw-rounded-xl tw-shadow-lg">
       <div className="tw-overflow-x-auto">
            <table className="tw-w-full tw-min-w-[700px] tw-border-collapse tw-text-center">
              <thead className="tw-bg-[#1e6ebe]">
                <tr>
                  <th className="tw-border tw-p-2  tw-text-[10px] sm:tw-text-[11px] md:tw-text-[13px] tw-font-semibold !tw-text-white">
                    Date
                  </th>
                {(loading ? Array.from({ length: skeletonCols }) : headers).map(
                  (time, i) => (
                    <th
                      key={i}
                      className="tw-border tw-p-1  tw-text-[10px] sm:tw-text-[11px] md:tw-text-[13px] tw-font-semibold !tw-text-white"
                    >
                      {loading ? (
                        <div className="tw-h-4 tw-w-16 tw-bg-white/40 tw-rounded tw-animate-pulse tw-not-sr-onlymx-auto" />
                      ) : (
                        time
                      )}
                    </th>
                  )
                )}
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {/* Skeleton Rows */}
              {loading &&
                Array.from({ length: skeletonRows }).map((_, i) => (
                  <tr key={i}>
                    <td className="tw-border tw-p-3 tw-sticky tw-left-0 tw-bg-color">
                      <div className="tw-h-4 tw-w-20 tw-bg-white/40 tw-rounded tw-animate-pulse tw-mx-auto" />
                    </td>
                    {Array.from({ length: skeletonCols }).map((_, j) => (
                      <td key={j} className="tw-border tw-p-3">
                        <div className="tw-h-4 tw-w-10 tw-bg-gray-300 tw-rounded tw-animate-pulse tw-mx-auto" />
                      </td>
                    ))}
                  </tr>
                ))}

              {/* Real Data */}
              {!loading &&
                data.map((day, i) => (
                  <tr
                    key={i}
                    className="odd:tw-bg-gray-50 hover:tw-bg-teal-50 tw-transition"
                  >
                    <td className="tw-border tw-p-2 md:tw-p-3 tw-font-semibold tw-sticky tw-left-0 tw-bg-color tw-text-gray-700">
                      {day.resultDate}
                    </td>

                    {headers.map((time, j) => {
                      const match = day.results.find(
                        (r) =>
                          r.providerName === time &&
                          r.winningDigit &&
                          r.winningDigit !== "**"
                      );

                      return (
                        <td
                          key={j}
                          className="border p-2 md:p-3 font-bold text-gray-800 min-w-[90px]"
                        >
                          {match?.winningDigit || "**"}
                        </td>
                      );
                    })}
                  </tr>
                ))}
            </tbody>
          </table>

          {/* Scroll target */}
          <div ref={bottomRef} />
        </div>
      </div>

       {/* Back Button */}
            <div className="tw-flex tw-justify-center tw-mt-3 md:tw-mt-8 ">
              <button
                onClick={() => navigate(-1)}
                className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-gap-2 hover:tw-scale-105 tw-transition"
              >
                <ArrowLeft className="tw-w-4 tw-h-4" />
                Back
              </button>
            </div>

      {!loading && data.length === 0 && (
        <p className="text-center mt-8 text-gray-500 font-semibold">
          No data found
        </p>
      )}
    </div>
  );
}
